/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lessons_Confirm_NowInputs */

const en_lessons_confirm_now = /** @type {(inputs: Lessons_Confirm_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm now`)
};

const he_lessons_confirm_now = /** @type {(inputs: Lessons_Confirm_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אישור עכשיו`)
};

/**
* | output |
* | --- |
* | "Confirm now" |
*
* @param {Lessons_Confirm_NowInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const lessons_confirm_now = /** @type {((inputs?: Lessons_Confirm_NowInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lessons_Confirm_NowInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lessons_confirm_now(inputs)
	return he_lessons_confirm_now(inputs)
});